module.exports = __webpack_public_path__ + "static/media/carrier-smartcomfort.0419c0ac.webp";